import produce from 'immer';
import { useCallback } from 'react';
import { usePlaylist, useUpdatePlaylist } from '../savedItems/savedItemsQueries';
export const swapArrayItems = (items, fromIndex, toIndex) => {
  items.splice(toIndex, 0, items.splice(fromIndex, 1)[0]);
  return items;
};
export const useUpdatePlaylistItemPosition = (playlistId, {
  onError
} = {}) => {
  const {
    playlist
  } = usePlaylist(playlistId);
  const [updatePlaylist] = useUpdatePlaylist(playlistId, {
    onError
  });
  const updatePlaylistItemPosition = useCallback((fromIndex, toIndex) => {
    const newPlaylist = produce(playlist, draft => {
      swapArrayItems(draft.items, fromIndex, toIndex);
    });
    return updatePlaylist(newPlaylist, {
      optimisticResponse: true
    });
  }, [playlist, updatePlaylist]);
  return updatePlaylistItemPosition;
};